/**
 *
 */
export class ReadLargePropertyParametersVisitor {
    constructor(value) {
        if (!value) {
            throw new Error('ReadLargePropertyParametersVisitor -- null value exception');
        }
        if (typeof value === 'string') {
            this._enclosedJsonObject = JSON.parse(value);
        }
        else {
            this._enclosedJsonObject = value;
        }
    }
    // --- State Management Helpers --- //
    static visitSequence(jsonObject) {
        return (new ReadLargePropertyParametersVisitor(jsonObject)).visitSequence();
    }
    // --- State Import/Export --- //
    copyAsJsonObject() {
        return JSON.parse(this.copyAsJsonString());
    }
    copyAsJsonString() {
        return JSON.stringify(this.enclosedJsonObject());
    }
    enclosedJsonObject() {
        return this._enclosedJsonObject;
    }
    // --- State Management --- //
    visitSequence() {
        return this.enclosedJsonObject().sequence;
    }
}
